export default __webpack_public_path__ + "static/media/Capture3.2b625713.PNG";